import * as React from 'react';
const RadioGroupContext = React.createContext(null);
export const RadioGroupContextProvider = RadioGroupContext.Provider;
export default RadioGroupContext;
export const RadioOptionTypeContext = React.createContext(null);
export const RadioOptionTypeContextProvider = RadioOptionTypeContext.Provider;
